import {
  ErrorTypes,
} from '@layers/web/constants/error.ts'

class SearchAbortedError extends Error {
  constructor () {
    super('Search was aborted')
    this.name = ErrorTypes.PACKAGE_SEARCH_ABORTED
  }
}

// Todo: to be removed later on, once we see different service down errors (kept for learning purposes)
class ServiceDownError extends Error {
  public readonly data: unknown

  constructor (public readonly originalError: any) {
    super(originalError?.message || 'Service is down')
    this.name = 'ServiceDownError'
    this.data = originalError?.data
  }
}

class CalendarTimeoutError extends Error {
  public readonly data: unknown

  constructor (public readonly originalError: any) {
    super(originalError?.message || 'Calendar search timed out')
    this.name = 'CalendarTimeoutError'
    this.data = originalError?.data
  }
}

class StateExpiredError extends Error {
  constructor () {
    super('Booking state has expired')
    this.name = ErrorTypes.STATE_EXPIRED
  }
}

class InvalidParamsError extends Error {
  constructor () {
    super('Invalid parameters')
    this.name = ErrorTypes.INVALID_PARAMS
  }
}

class StateAbortedError extends Error {
  constructor () {
    super('The state request was aborted')
    this.name = ErrorTypes.STATE_ABORTED
  }
}

class WaitinglistError extends Error {
  constructor () {
    super('Room type is on waitinglist')
    this.name = ErrorTypes.WAITINGLIST
  }
}

class InvalidTripError extends Error {
  constructor () {
    super('Invalid trip type for new booking')
    this.name = ErrorTypes.INVALID_TRIP
  }
}

export {
  SearchAbortedError,
  StateAbortedError,
  ServiceDownError,
  CalendarTimeoutError,
  StateExpiredError,
  WaitinglistError,
  InvalidTripError,
  InvalidParamsError,
}
